module.exports = __webpack_public_path__ + "img/1.de105f81.jpg";